import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Form, Card, Col, Row } from '_zari/core'

import * as CategoriaService from 'services/categoria.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CrearEditarCategoriaSection = ({ editarData, refrescarTabla, refrescarSection }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      nombre: editarData.nombre || ''
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    data => {
      const promiseAction = editarData._id
        ? () => CategoriaService.actualizarxId(editarData._id, data)
        : () => CategoriaService.nuevo(data)

      promiseAction()
        .then(() => {
          __zariContext.toast(
            'success',
            editarData._id ? 'El registro se ha actualizado.' : 'El registro se ha creado.'
          )
          refrescarTabla()
          refrescarSection()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, editarData, refrescarTabla, refrescarSection]
  )

  return (
    <Card>
      <Card.Header>{editarData._id ? 'Editar Categoria' : 'Nueva Categoria'}</Card.Header>
      <Card.Body>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleSubmit, isSubmitting, touched }) => (
            <Form>
              <FormGroups.NombreFormGroup
                iError={errors.nombre}
                iTouched={touched.nombre}
                fIsSubmitting={isSubmitting}
              />
              <Row className='mt-2'>
                <Col md={12} className='text-right'>
                  <Button color='secondary' onClick={refrescarSection}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default React.memo(CrearEditarCategoriaSection)
